export function normalizeVbCode(raw: string): string {
  if (!raw) return '';
  // Normaliza quebras de linha e remove BOM se houver
  let code = raw.replace(/\uFEFF/g, '');
  code = code.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
  // Aspas curvas → aspas retas
  code = code.replace(/[\u201C\u201D]/g, '"').replace(/[\u2018\u2019]/g, "'");
  return code;
}

export interface VbcompilerParams {
  vbid: string;
  code: string;
  progress?: boolean;
  progressEvery?: number;
  progressIntervalMs?: number;
  progressLabel?: string;
  uiModal?: boolean;
  uiCancelable?: boolean;
}

export function buildVbcompilerPayload(params: VbcompilerParams) {
  const {
    vbid,
    code,
    progress = false,
    progressEvery = 0,
    progressIntervalMs = 0,
    progressLabel = 'Conversão/Bitmap',
    uiModal = false,
    uiCancelable = false
  } = params;

  return {
    action: 'vbcompiler',
    data: {
      vbid,
      code: normalizeVbCode(code),
      parameters: {},
      progress,
      ...(progress ? { progressEvery, progressIntervalMs, progressLabel } : {}),
      ...(uiModal ? { uiModal: true } : {}),
      ...(uiCancelable ? { uiCancelable: true } : {})
    }
  };
}

export function validatePayload(p: any): string[] {
  const errs: string[] = [];
  if (!p || typeof p !== 'object') errs.push('payload ausente');
  if (!p.data) errs.push('data ausente');
  if (!p?.data?.code) errs.push('data.code ausente');
  const code: string = p?.data?.code || '';
  const size = new Blob([code]).size;
  if (size > 20 * 1024) errs.push('data.code excede 20KB');
  if (typeof p?.data?.progress === 'boolean') {
    if (p.data.progress && p.data.progressEvery != null && typeof p.data.progressEvery !== 'number') errs.push('progressEvery deve ser number');
    if (p.data.progress && p.data.progressIntervalMs != null && typeof p.data.progressIntervalMs !== 'number') errs.push('progressIntervalMs deve ser number');
  }
  return errs;
}


